export default __webpack_public_path__ + "adbc39fad9368ab47d1ee3a64ef79198.svg";